function isVideoVisible(video) {
    return window.getComputedStyle(video).display !== 'none' && video.getClientRects().length > 0;
}

function getVideoPlayers(root) {
    if (!root || root === document) {
        return Array.from(document.querySelectorAll('[data-video-mute-container], .banner-section'));
    }

    if (root.matches('[data-video-mute-container], .banner-section')) {
        return [root];
    }

    const parent = root.closest('[data-video-mute-container], .banner-section');
    return parent ? [parent] : [];
}

function syncResponsiveVideos(root) {
    getVideoPlayers(root).forEach(function (player) {
        const muteButton = player.querySelector('[data-banner-mute]');
        const shouldUnmute = muteButton && muteButton.dataset.muted === 'false';

        player.querySelectorAll('video').forEach(function (video) {
            if (!isVideoVisible(video)) {
                video.pause();
                video.muted = true;
                return;
            }

            if (muteButton) {
                video.muted = !shouldUnmute;
            }

            if (video.paused && video.hasAttribute('autoplay')) {
                video.play().catch(function () {});
            }
        });
    });

    if (!root || root === document) {
        document.querySelectorAll('.media-container[data-media-type="video"]').forEach(function (container) {
            if (container.closest('[data-video-mute-container], .banner-section')) return;

            container.querySelectorAll('video').forEach(function (video) {
                if (!isVideoVisible(video)) {
                    video.pause();
                    video.muted = true;
                    return;
                }

                if (video.paused && video.hasAttribute('autoplay')) {
                    video.play().catch(function () {});
                }
            });
        });
    }
}

window.syncResponsiveVideos = syncResponsiveVideos;

document.addEventListener('DOMContentLoaded', function() {
    // Your code here
    // Image lazy load handling
    const allMediaSections = document.querySelectorAll('.media-container');
    const allImgsSwitcherWrappers = document.querySelectorAll('.banner-with-switching-images');
    const allAlbumSections = document.querySelectorAll('.album-section');
    var device = window.innerWidth < 768 ? 'mobile' : 'desktop';
    function reload() {
        allMediaSections.forEach(section => {
            loadMedia(section);
        })
        allImgsSwitcherWrappers.forEach(section => {
            loadMediaForImgsSwitcherWrapper(section);
        })
        syncResponsiveVideos();
    }
    function windowResizeHandler() {
        window.addEventListener('resize', () => {
            let newDevice = window.innerWidth < 768 ? 'mobile' : 'desktop';
            if (newDevice !== device) {
                console.log("device changed from", device, "to", newDevice);
                device = newDevice;
                reload();
            }
        })
    }
    function loadMedia(container) {
        // Handle responsive image sizes
        const imgs = container.querySelectorAll(device=="mobile"?'img.lazyload-mobile':'img.lazyload');
        console.log("loading media for device:", device, imgs);
        imgs.forEach(img => {
            if (!img.dataset.srcset) return; //If it is removed, that means image is already loaded
            img.srcset = img.dataset.srcset;
            //after image load add show class
            img.onload = () => {container.classList.add('show');}
            img.removeAttribute('data-srcset');
        });
        const vids = container.querySelectorAll(device=="mobile"?'video.lazyload-mobile':'video.lazyload');
        console.log("loading media for device:", device, vids);
        vids.forEach(vid => {
            const source = vid.querySelector('source');
            if (source?.dataset?.src) {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
                vid.load();
            }
            const markShown = () => container.classList.add('show');
            if (vid.readyState >= 2) {
                markShown();
            } else {
                vid.addEventListener('loadeddata', markShown, { once: true });
                vid.addEventListener('canplay', markShown, { once: true });
            }
        });
        syncResponsiveVideos();
    }
    function setupIntersectionObserversForMediaSections() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    //Load the media in this media section
                    loadMedia(entry.target);
                    console.log('Loading media for section:', entry.target);
                    observer.unobserve(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: '50px 0px' 
        });
        allMediaSections.forEach(mediaSection => {    
            observer.observe(mediaSection);
        });
    }
    function startAnimation(switcherImgsContainer, allSwitcherImgs) {
        //Immediately hide first image and show second, then switch every 1 second
        let currentIndex = parseInt(switcherImgsContainer.dataset.currentIndex) || 0;
        const totalImages = allSwitcherImgs.length;
        //Every 1.5 seconds, change the image
        setInterval(() => {
            // If not last image, hide the current index and show the next
            if (currentIndex < totalImages - 1) {
                allSwitcherImgs[currentIndex].classList.remove('active');
                currentIndex += 1;
                allSwitcherImgs[currentIndex].classList.add('active');
            } else {
                //Show the first image and then hide the last
                allSwitcherImgs[0].classList.add('active');
                allSwitcherImgs[currentIndex].classList.remove('active');
                currentIndex = 0;
            }
            switcherImgsContainer.dataset.currentIndex = currentIndex;
        }, 800);
    }
    function checkIfLoadedAndStartAnimation(switcherImgsContainer, allSwitcherImgs) {
        //Ever 1 seconds check if all images in allSwitcherImgs are loaded
        const interval = setInterval(() => {
            const allLoaded = Array.from(allSwitcherImgs).every(img => !img.dataset.src);
            if (allLoaded) {
                clearInterval(interval);
                //Start the animation
                startAnimation(switcherImgsContainer,allSwitcherImgs);
            }
        }, 1000);
    }
    function loadOtherImages(switcherImgsContainer,allSwitcherImgs){
        for (let i = 1; i < allSwitcherImgs.length; i++) {
            const img = allSwitcherImgs[i];
            if (img?.dataset?.src) {
                img.src = img.dataset.src;
                img.onload = () => {
                    img.removeAttribute('data-src');
                }
            }
        }
        checkIfLoadedAndStartAnimation(switcherImgsContainer,allSwitcherImgs)
    }
    function loadMediaForImgsSwitcherWrapper(wrapper) {
        const switcherImgsContainer = wrapper.querySelector(device=="mobile"?'.mobile-switcher-imgs':' .desktop-switcher-imgs');
        console.log("loading media for switch container", device, switcherImgsContainer);
        if (!switcherImgsContainer) return;
        const allSwitcherImgs = switcherImgsContainer.querySelectorAll('.switcher-img');
        //First load the first item in allSwitcherImgs
        //The load the rest
        if (allSwitcherImgs.length > 0) {
            const firstImg = allSwitcherImgs[0];
            if (firstImg?.dataset?.src) {
                firstImg.src = firstImg.dataset.src;
                firstImg.onload = () => {
                    firstImg.removeAttribute('data-src');
                    //Add active class to first image
                    firstImg.classList.add('active');
                    //Need to do animation only if there is more than 1 image
                    if (allSwitcherImgs.length > 1) {
                        loadOtherImages(switcherImgsContainer, allSwitcherImgs);
                    }
                }
            } else {
                if (allSwitcherImgs.length > 1) {
                    loadOtherImages(switcherImgsContainer, allSwitcherImgs);
                }
            }
        }
        //Once all images are loaded, start the animation
    
    }
    function setupIntersectionObserversForImgsSwitcherWrappers() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    //Load the media in this media section
                    loadMediaForImgsSwitcherWrapper(entry.target);
                    console.log('Loading media for imgs switcher:', entry.target);
                    observer.unobserve(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: '200px 0px' 
        });
        allImgsSwitcherWrappers.forEach(wrapper => {    
            observer.observe(wrapper);
        });
    }
    function mobileMenuHandlers() {
        const hamburgerMenu = document.querySelector('.hamburger-menu');
        const body = document.body;
        const closeMenuDrawer = document.querySelector('.close-menu-drawer');
        console.log("doms", hamburgerMenu, body, closeMenuDrawer);
        hamburgerMenu?.addEventListener('click', () => {
            body?.classList.add('menu-drawer-open');
        });
        closeMenuDrawer?.addEventListener('click', () => {
            body?.classList.remove('menu-drawer-open');
        });
    }

    let albumRecalculateTimeout;

    function recalculateAlbumScroll() {
        setupAlbumScrollAnimation();
        handleAlbumScroll();
    }

    function scheduleAlbumRecalculate() {
        clearTimeout(albumRecalculateTimeout);
        albumRecalculateTimeout = setTimeout(recalculateAlbumScroll, 100);
    }

    function setupAlbumScrollAnimation() {
        allAlbumSections.forEach(albumSection => {
            const albumImages = albumSection.querySelector('.album-images');
            const albumViewport = albumSection.querySelector('.album-images-viewport');
            const albumStickyTrack = albumSection.querySelector('.album-sticky-track');
            const albumHeader = albumSection.querySelector('.album-section-header');
            const albumImageItems = albumSection.querySelectorAll('.album-image');
            const albumWrapper = albumSection.closest('.album-section-wrapper');

            if (!albumImages || !albumViewport || !albumStickyTrack || albumImageItems.length === 0) return;

            albumImages.style.width = 'max-content';

            const totalImagesWidth = albumImages.scrollWidth;
            const containerWidth = albumViewport.offsetWidth;
            const maxTranslateX = Math.max(0, totalImagesWidth - containerWidth);
            const viewportHeight = albumViewport.offsetHeight;
            const headerHeight = albumHeader ? albumHeader.offsetHeight : 0;
            const stickyStart = Math.max(0, headerHeight + viewportHeight - window.innerHeight);

            if (maxTranslateX > 0) {
                albumStickyTrack.style.height = `${viewportHeight + maxTranslateX}px`;
                albumWrapper.style.height = '';
                albumViewport.style.setProperty('--album-sticky-top', `${window.innerHeight - viewportHeight}px`);

                albumSection.dataset.maxTranslateX = maxTranslateX;
                albumSection.dataset.scrollDistanceNeeded = maxTranslateX;
                albumSection.dataset.stickyStart = stickyStart;
            } else {
                albumStickyTrack.style.height = '';
                albumWrapper.style.height = '';
                albumViewport.style.removeProperty('--album-sticky-top');
                delete albumSection.dataset.maxTranslateX;
                delete albumSection.dataset.scrollDistanceNeeded;
                delete albumSection.dataset.stickyStart;
            }
        });
    }

    function handleAlbumScroll() {
        allAlbumSections.forEach(albumSection => {
            const albumImages = albumSection.querySelector('.album-images');
            const albumViewport = albumSection.querySelector('.album-images-viewport');
            const albumWrapper = albumSection.closest('.album-section-wrapper');

            if (!albumImages || !albumViewport) return;

            const albumClip = albumSection.querySelector('.album-images-clip');
            if (albumClip && albumClip.scrollLeft !== 0) {
                albumClip.scrollLeft = 0;
            }

            const maxTranslateX = parseFloat(albumSection.dataset.maxTranslateX) || 0;
            const scrollDistanceNeeded = parseFloat(albumSection.dataset.scrollDistanceNeeded) || 0;
            const stickyStart = parseFloat(albumSection.dataset.stickyStart) || 0;

            if (maxTranslateX <= 0) return;

            const wrapperRect = albumWrapper.getBoundingClientRect();
            const wrapperTop = wrapperRect.top;
            const wrapperBottom = wrapperRect.bottom;
            const scrollIntoWrapper = Math.max(0, -wrapperTop);
            const scrollIntoAnimation = Math.max(0, scrollIntoWrapper - stickyStart);

            if (wrapperBottom <= 0) {
                albumImages.style.transform = `translateX(-${maxTranslateX}px)`;
            } else if (scrollIntoWrapper < stickyStart) {
                albumImages.style.transform = 'translateX(0px)';
            } else if (scrollIntoAnimation <= scrollDistanceNeeded) {
                const scrollProgress = Math.min(1, scrollIntoAnimation / scrollDistanceNeeded);
                const translateX = scrollProgress * maxTranslateX;
                albumImages.style.transform = `translateX(-${translateX}px)`;
            } else {
                albumImages.style.transform = `translateX(-${maxTranslateX}px)`;
            }
        });
    }

    function setupAlbumScrollListeners() {
        recalculateAlbumScroll();

        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleAlbumScroll();
                    ticking = false;
                });
                ticking = true;
            }
        }

        window.addEventListener('scroll', requestTick);
        window.addEventListener('load', scheduleAlbumRecalculate);
        window.addEventListener('resize', scheduleAlbumRecalculate);

        if (typeof ResizeObserver !== 'undefined') {
            const albumResizeObserver = new ResizeObserver(scheduleAlbumRecalculate);
            allAlbumSections.forEach(albumSection => {
                albumResizeObserver.observe(albumSection);
            });
        }
    }
    windowResizeHandler();
    setupIntersectionObserversForMediaSections();
    setupIntersectionObserversForImgsSwitcherWrappers();
    setupAlbumScrollListeners();
    mobileMenuHandlers();
    syncResponsiveVideos();
});